import React from 'react'

function Clients() {
  return (
    <div>
      clients text
    </div>
  )
}

export default Clients
